import { render, staticRenderFns } from "./SightingsItemDetails.vue?vue&type=template&id=79b63774"
import script from "./SightingsItemDetails.vue?vue&type=script&lang=js"
export * from "./SightingsItemDetails.vue?vue&type=script&lang=js"
import style0 from "./SightingsItemDetails.vue?vue&type=style&index=0&id=79b63774&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports